import React, { createContext, useCallback, useContext, useState } from "react";
import WhatsAppModal from "../components/WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "./useFirestoreData";
import { getUtmParams, openWhatsAppConsulta } from "./whatsappConfig";

const WhatsAppConsultaContext = createContext(null);

export const WhatsAppConsultaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const { utm_source, utm_medium, utm_campaign } = getUtmParams();
      await updateData({ ...values, utm_source, utm_medium, utm_campaign });
      setOpen(false);
      openWhatsAppConsulta();
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const openConsultaForm = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      <WhatsAppModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleModalSubmit}
        loading={loading}
      />
    </WhatsAppConsultaContext.Provider>
  );
};

export const useWhatsAppConsulta = () => {
  const context = useContext(WhatsAppConsultaContext);
  if (!context) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return context;
};
